module.exports = __webpack_public_path__ + "img/data.d4abf419.png";